export type PublishingInitRequest = {
    id: string;
    name: string;
    description?: string;
    prefix?: string;
    modelIds: string[];
}

export enum PublishingJobStatus {
    Queued = "Queued",
    InProgress = "InProgress",
    Completed = "Completed",
    Failed = "Failed",
}

export type PublishingJob = {
    id: string;
    status: PublishingJobStatus;
    uploadedBytes: number;
    totalBytes: number;
    error?: string;
    result?: { schemaId: string; schemaName: string };
}

export const isPublishingJobActive = (job?: PublishingJob) =>
    job?.status === PublishingJobStatus.Queued || job?.status === PublishingJobStatus.InProgress;
